'use strict';

(function ($, Swiper, Promise) {
    var $productSlider = $('#jwsdw-jacketFinder-productSlider'),
        $productSearchResult = $('#jwsdw-jacketFinder-searchResult'),
        $productDetail = $('#jwsdw-jacketFinder-productDetail'),
        $productSlideTemplate = $('#jwsdw-jacketFinder-productSlide-template'),
        $productSlidePlaceholderTemplate = $('#jwsdw-jacketFinder-placeholder-template'),
        $productDetailTemplate = $('#jwsdw-jacketFinder-productDetail-template'),
        $technologyLogoTemplate = $('#jwsdw-jacketFinder-technologyLogo-template'),
        $typeSelect = $('.jwsdw-jacketFinder-type'),
        $activitySelectWrapper = $('#jwsdw-jacketFinder-activitySelect'),
        $activitySelect = $('.jwsdw-jacketFinder-activity'),
        $functionSelectWrapper = $('#jwsdw-jacketFinder-functionSelect'),
        $functionSelect = $('.jwsdw-jacketFinder-function'),
        $attributeSelectWrapper = $('#jwsdw-jacketFinder-attributeSelect'),
        $attributeSelect = $('.jwsdw-jacketFinder-attribute'),
        $nextLinkActivity = $('.jwsdw-jacketFinder-nextLink-activity'),
        $nextLinkFunction = $('.jwsdw-jacketFinder-nextLink-function'),
        $nextLinkAttribute = $('.jwsdw-jacketFinder-nextLink-attribute'),
        $nextLinkResults = $('.jwsdw-jacketFinder-nextLink-results'),
        $searchResults = $('#jwsdw-jacketFinder-searchResult'),
        _cache = {},
        _selectedProduct,
        _compareWith,
        _disableAutoScroll = false,
        _productSearchHits = [],
        _offset = 0,
        sliders = {
            'product': null,
            'productDetail': {}
        },
        sliderOptions = {
            'productSlider': {
                'init': false,
                'loop': false,
                'freeMode': true,
                'preloadImages': false,
                'slidesPerView': 2,
                'spaceBetween': 10,
                'centerInsufficientSlides': true,
                // Responsive breakpoints
                'breakpoints': {
                    // when window width is >= 600px
                    '600': {
                        'slidesPerView': 3,
                        'spaceBetween': 15
                    },
                    // when window width is >= 767px
                    '767': {
                        'slidesPerView': 4,
                        'spaceBetween': 20
                    },
                    // when window width is >= 1200px
                    '1200': {
                        'slidesPerView': 4,
                        'spaceBetween': 20
                    }
                },
                'navigation': {
                    'nextEl': '.swiper-button-next',
                    'prevEl': '.swiper-button-prev'
                }
            },
            'productDetailSlider': {
                'init': false,
                'loop': true,
                'freeMode': false,
                'preloadImages': false,
                'slidesPerView': 1,
                'threshold': 10,
                'slideThumbActiveClass': 'jwsdw-selected',
                'autoScrollOffset': 1,
                'navigation': {
                    'nextEl': '.swiper-button-next',
                    'prevEl': '.swiper-button-prev'
                }
            }
        },
        transforms = {
            'slider': {
                'scaleWidth': 360,
                'format': 'jpg'
            },
            'productDetail': {
                'scaleWidth': 600,
                'format': 'jpg'
            }
        },
        filterHitCountXhrs = [],
        xhrs = [];

    // check the category and select the appropriate one on load
    if (window.currentCategory) {
        if (window.currentCategory.split('-')[0] === "Damen") {
            $('.jwsdw-jacketFinder-type').eq(1).prop("checked", true);
        }
        if (window.currentCategory.split('-')[0] === "Herren") {
            $('.jwsdw-jacketFinder-type').eq(0).prop("checked", true);
        }
    }
    search(buildHTML, true);
    getFilterHitCount(deactivateEmptyRefinements, true, true, true);

    $('a[href^="#"]').click(function(e) {
        var $element = $($(this).attr('href'));
        e.preventDefault();

        if ($element.length === 1) {
            scrollTop($element, -55);
        }
    });

    $('.jwsdw-productFinder-infoWrapper').click(function() {
        window.jwsdwMediator.publish('openPicker', 'infoPicker', {
            'content': $(this).data('info')
        });
    });

    $nextLinkActivity.on('click', function() {
        if (!_disableAutoScroll) {
            setTimeout(function() {
                scrollTop($activitySelectWrapper, -55);
            }, 500);
        }
    });

    $nextLinkFunction.on('click', function() {
        if (!_disableAutoScroll) {
            setTimeout(function() {
                scrollTop($functionSelectWrapper, -55);
            }, 500);
        }
    });

    $nextLinkAttribute.on('click', function() {
        if (!_disableAutoScroll) {
            setTimeout(function() {
                scrollTop($attributeSelectWrapper, -55);
            }, 500);
        }
    });

    $nextLinkResults.on('click', function() {
        if (!_disableAutoScroll) {
            setTimeout(function() {
                scrollTop($searchResults, -55);
            }, 500);
        }
    });

    $typeSelect.on('click', function () {
        _disableAutoScroll = true;
        $functionSelect.prop('checked', false);
        $attributeSelect.prop('checked', false);
        $('#jwsdw-jacketFinder-activity-none').removeAttr('disabled').prop('checked', true);
        $('#jwsdw-jacketFinder-function-none').removeAttr('disabled').prop('checked', true);
        $('#jwsdw-jacketFinder-attribute-none').removeAttr('disabled').prop('checked', true);
        _disableAutoScroll = false;
        $('.jwsdw-jacketFinder-activity').attr('disabled', 'disabled');
        $('.jwsdw-jacketFinder-function').attr('disabled', 'disabled');
        $('.jwsdw-jacketFinder-attribute').attr('disabled', 'disabled');
        $('.jwsdw-jacketFinder-activity').next('.jwsdw-productFinder-refinementStep-tile').find('.jwsdw-spinner').removeClass('jws-hidden');
        $('.jwsdw-jacketFinder-function').next('.jwsdw-productFinder-refinementStep-tile').find('.jwsdw-spinner').removeClass('jws-hidden');
        $('.jwsdw-jacketFinder-attribute').next('.jwsdw-productFinder-refinementStep-tile').find('.jwsdw-spinner').removeClass('jws-hidden');

        search(buildHTML, true);
        getFilterHitCount(deactivateEmptyRefinements, true, true, true);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'ce.advice',
            'eventCategory': 'Advice',
            'eventAction': 'Jacket Finder',
            'eventLabel': '1',
            'eventValue': undefined,
            'nonInteraction': false,
            'selection': $('#jwsdw-jacketFinder-typeSelect input:checked').val()
        });
    });

    $activitySelect.on('click', function () {
        _disableAutoScroll = true;
        $functionSelect.prop('checked', false);
        $attributeSelect.prop('checked', false);
        $('#jwsdw-jacketFinder-function-none').removeAttr('disabled').prop('checked', true);
        $('#jwsdw-jacketFinder-attribute-none').removeAttr('disabled').prop('checked', true);
        _disableAutoScroll = false;
        $('.jwsdw-jacketFinder-function').attr('disabled', 'disabled');
        $('.jwsdw-jacketFinder-function').next('.jwsdw-productFinder-refinementStep-tile').find('.jwsdw-spinner').removeClass('jws-hidden');

        $('.jwsdw-jacketFinder-activity').each(function () {
            if ($(this).is(":checked")) {
                $(this).parent().removeClass('jwsdw-borderGrey5');
            } else {
                $(this).parent().addClass('jwsdw-borderGrey5');
            }
        });

        search(buildHTML, true);
        getFilterHitCount(deactivateEmptyRefinements, true, true, true);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'ce.advice',
            'eventCategory': 'Advice',
            'eventAction': 'Jacket Finder',
            'eventLabel': '2',
            'eventValue': undefined,
            'nonInteraction': false,
            'selection': $('#jwsdw-jacketFinder-activitySelect input:checked').val()
        });
    });

    $functionSelect.on('click', function () {
        $attributeSelect.prop('checked', false);
        $('#jwsdw-jacketFinder-attribute-none').removeAttr('disabled').prop('checked', true);
        if ($(this).val() === '') {
            $functionSelect.prop('checked', false);
            $(this).prop('checked', true);
        } else {
            $('#jwsdw-jacketFinder-function-none').removeAttr('disabled').prop('checked', false);
        }

        search(buildHTML, true);
        getFilterHitCount(deactivateEmptyRefinements, true, true, true);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'ce.advice',
            'eventCategory': 'Advice',
            'eventAction': 'Jacket Finder',
            'eventLabel': '3',
            'eventValue': undefined,
            'nonInteraction': false,
            'selection': $('#jwsdw-jacketFinder-functionSelect input:checked').val()
        });
    });

    $attributeSelect.on('click', function () {
        if ($(this).val() === '') {
            $attributeSelect.prop('checked', false);
            $(this).prop('checked', true);
        } else {
            $('#jwsdw-jacketFinder-attribute-none').removeAttr('disabled').prop('checked', false);
        }

        $('.jwsdw-jacketFinder-attribute').each(function () {
            if ($(this).is(":checked")) {
                $(this).parent().removeClass('jwsdw-borderGrey5');
            } else {
                $(this).parent().addClass('jwsdw-borderGrey5');
            }
        });

        search(buildHTML, true);
        getFilterHitCount(deactivateEmptyRefinements, true, true, true);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'ce.advice',
            'eventCategory': 'Advice',
            'eventAction': 'Jacket Finder',
            'eventLabel': 'finished',
            'eventValue': undefined,
            'nonInteraction': false,
            'selection': $('#jwsdw-jacketFinder-attributeSelect input:checked').val()
        });
    });

    $(document).on('click', '.jwsdw-product-tiles-grid-wrapper .jwsdw-productTile .jwsdw-product-variation', function(e) {
        e.preventDefault();
        _selectedProduct = $(this).attr('data-product-id');

        $('.jwsdw-product-tiles-grid-wrapper .jwsdw-productTile .jwsdw-product-variation').removeClass('jwsdw-selected');
        $(this).addClass('jwsdw-selected');

        $productDetail.find('.jwsdw-jacketFinder-productDetail-product').each(function(i, el) {
            $(el).removeClass('jws-visuallyHidden');
            buildProductDetail(_productSearchHits, _selectedProduct);
        });
    });

    $(document).on('click', '#jwsdw-jacketFinder-productSlider .jwsdw-jacketFinder-productSlide', function() {
        _selectedProduct = $(this).attr('data-product-id');

        $('#jwsdw-jacketFinder-productSlider .jwsdw-jacketFinder-productSlide').removeClass('jwsdw-selected');
        $(this).addClass('jwsdw-selected');

        buildProductDetail(_productSearchHits, _selectedProduct);
        $productDetail.find('.jwsdw-jacketFinder-productDetail-product').each(function(i, el) {
            $(el).removeClass('jws-visuallyHidden');
        });
    });

    $(document).on('click', '#jwsdw-jacketFinder-productSlider-prev', function() {
        $productSlider.find('.swiper-button-prev').click();
    });
    $(document).on('click', '#jwsdw-jacketFinder-productSlider-next', function() {
        $productSlider.find('.swiper-button-next').click();
    });


    $(document).on('click', '.jwsdw-jacketFinder-shopNow', function () {
        window.jwsdwMediator.publish('openPicker', 'productDetailPicker', {
            'productId': $(this).data('product-id'),
            'showRefinements': false
        });
    });

    $(document).on('click', '.jwsdw-jacketFinder-compare', function () {
        let $comparePickerContent = $('#jwsdw-jacketFinder-comparePicker-template').clone(),
            cgids = [],
            allResults;

        window.jwsdwMediator.publish('openPicker', 'infoPicker', {
            'content': '<div class="jwsdw-jacketFinder-compare-container"></div>'
        });

        if ($('.jwsdw-jacketFinder-type:checked').val()) {
            cgids = [
                buildCategoryId(
                    $('.jwsdw-jacketFinder-type:checked').val()
                )
            ];
        } else {
            cgids = [
                buildCategoryId(
                    $('.jwsdw-jacketFinder-type').eq(0).val()
                ),
                buildCategoryId(
                    $('.jwsdw-jacketFinder-type').eq(1).val()
                )
            ];
        }

        allResults = cgids
            .map(function (cgid) {
                let data = cgid,
                    offsets,
                    result,
                    tempArr;

                if ($('.jwsdw-jacketFinder-activity:checked').val()) {
                    data += '-' + $('.jwsdw-jacketFinder-activity:checked').val();
                }

                if ($('.jwsdw-jacketFinder-function:checked').val()) {
                    tempArr = $('.jwsdw-jacketFinder-function:checked').map(function(){return $(this).val()}).get(); //eslint-disable-line
                    for (let i = 0; i < tempArr.length; i++) {
                        data += '-' + tempArr[i];
                    }
                }

                if ($('.jwsdw-jacketFinder-attribute:checked').val()) {
                    tempArr = $('.jwsdw-jacketFinder-attribute:checked').map(function(){return $(this).val()}).get(); //eslint-disable-line
                    for (let i = 0; i < tempArr.length; i++) {
                        data += '-' + tempArr[i];
                    }
                }

                offsets = Array.from({ 'length': Math.floor(_offset / 10) }, (_, i) => i * 10);

                offsets.forEach((start) => {
                    let currentSearch = data + (start ? '-' + start : ''),
                        cachedSearch = _cache[currentSearch];

                    if (cachedSearch) {
                        if (!result) {
                            result = Object.assign({}, cachedSearch);
                        } else {
                            result.productSearchHits = result.productSearchHits.concat(cachedSearch.productSearchHits);
                        }
                    }
                });

                return result;
            })
            .filter(Boolean);

        let productSearchHits;

        productSearchHits = allResults.reduce(function (arr, result) {
            if (!result.categoryId) {
                return arr;
            }
            return arr.concat(result.productSearchHits);
        }, []);

        productSearchHits
            .filter(function(product) {
                return product.ID !== _selectedProduct &&
                product.pricing.standard;
            })
            .forEach(function (product) {
                var $productTile = $productSlideTemplate.clone();
                $productTile.removeClass('jws-hidden').removeAttr('id');

                $productTile
                    .attr('data-product-id', product.ID)
                    .addClass('jws-grid-small-column-6');
                $productTile
                    .find('.jwsdw-productTile-image')
                    .attr(
                        'data-src',
                        window.jwsdwUtil.urlUtils.imageUrl(product.ID, 0, transforms.slider, 'Bone5')
                    )
                    .attr(
                        'alt',
                        product.displayedName || product.name
                    );
                $productTile.find('.jwsdw-productName').text(product.displayedName || product.name);
                if (product.pricing.sale && product.pricing.sale < product.pricing.standard) {
                    // has sale price
                    $productTile.find('.jwsdw-productListPrice')
                        .addClass('jwsdw-lineThrough jws-copy1 jws-colorGrey3')
                        .text(window.jwsdwUtil.formatPrice(product.pricing.standard));
                    $productTile.find('.jwsdw-productSalePrice')
                        .removeClass('jws-hidden')
                        .text(window.jwsdwUtil.formatPrice(product.pricing.sale));
                } else {
                    $productTile.find('.jwsdw-productListPrice').text(window.jwsdwUtil.formatPrice(product.pricing.standard));
                }
                $comparePickerContent.find('.jwsdw-jacketFinder-comparePicker-products').append($productTile);
            });

        setTimeout(function() {
            $('.jwsdw-jacketFinder-compare-container').html($comparePickerContent.html());
            $('.jwsdw-jacketFinder-compare-container').scrollTop(0);
        }, 150);
    });

    $(document).on('click', '.jwsdw-jacketFinder-comparePicker-products .jwsdw-jacketFinder-productSlide', function() {
        _compareWith = $(this).attr('data-product-id');

        $('.jwsdw-jacketFinder-comparePicker-products .jwsdw-jacketFinder-productSlide').removeClass('jwsdw-selected');
        $(this).addClass('jwsdw-selected');

        $('.jwsdw-jacketFinder-comparePicker-compare:visible').addClass('jws-buttonYellow');
        $('.jwsdw-jacketFinder-comparePicker-compare:visible').removeClass('jws-buttonGrey5');
        $('.jwsdw-jacketFinder-comparePicker-compare:visible').removeAttr('disabled');
        $('.jwsdw-jacketFinder-comparePicker-compare:visible').find('span').eq(0).addClass('jws-hidden');
        $('.jwsdw-jacketFinder-comparePicker-compare:visible').find('span').eq(1).removeClass('jws-hidden');
    });

    $(document).on('click', '.jwsdw-jacketFinder-comparePicker-compare', function() {
        _productSearchHits.filter(function(product) {
            return product.ID === _compareWith && product.pricing.standard;
        }).map(function (product) {
            var $productDetailProduct = $productDetailTemplate.clone();

            $productDetailProduct.find('.jwsdw-jacketFinder-productImage').attr(
                'src',
                window.jwsdwUtil.urlUtils.imageUrl(product.ID, 0, transforms.productDetail, 'Bone5')
            );

            $productDetailProduct.attr('data-product-id', product.ID);
            $productDetailProduct.attr('id', 'jwsdw-jacketFinder-productDetail-product-' + product.ID);

            $productDetailProduct.find('.jwsdw-productName').text(product.displayedName || product.name);
            $productDetailProduct.find('.jwsdw-productPrice').text(product.pricing.priceFormatted);
            $productDetailProduct.find('.jwsdw-jacketFinder-shopNow, .jwsdw-jacketFinder-compare, .jwsdw-jacketFinder-compare-remove').attr('data-product-id', product.ID);

            product.info.forEach(function (info) {
                $productDetailProduct.find('.jwsdw-pdp-detailList').append(
                    $('<li>' + info + '</li>')
                );
            });
            product.technology.forEach(function (technology) {
                var $technologyLogo = $technologyLogoTemplate.clone();

                $technologyLogo.removeAttr('id').removeClass('jws-hidden');
                if (technology.cid) {
                    $technologyLogo.find('.jwsdw-badgeContainer').addClass('jws-cursorPointer');
                    $technologyLogo.find('.jwsdw-badgeContainer').attr('data-picker-options', JSON.stringify({
                        'cid': technology.cid,
                        'introduction': technology.excerpt,
                        'width': 1
                    }));
                } else {
                    $technologyLogo.find('.jwsdw-badge').remove();
                }
                $technologyLogo.find('.jwsdw-techLogo').attr('src', technology.imageUrl);
                $productDetailProduct.find('.jwsdw-jacketFinder-productDetail-technologies').append($technologyLogo);
            });

            $productDetail.append($productDetailProduct);

            return product;
        });
        $productDetail.find('.jwsdw-jacketFinder-productDetail-product').addClass('jwsdw-jacketFinder-productDetail-compare');
        $productDetail.find('.jwsdw-jacketFinder-productDetail-product[data-product-id=' + _compareWith + ']').removeClass('jws-visuallyHidden');

        $productDetail.find('.jwsdw-jacketFinder-productDetail-product')
            .removeClass('jws-grid-small-column-10')
            .addClass('jws-grid-small-column-5');
        $productDetail.find('.jwsdw-jacketFinder-productImage-container').removeClass('jws-grid-medium-column-6');
        $productDetail.find('.jwsdw-jacketFinder-productDetail-container').removeClass('jws-grid-medium-column-6');
        $productDetail.find('.jws-headline3, .jws-headline4').addClass('jws-textAlignCenter');
        $productDetail.find('.jwsdw-jacketFinder-productDetail-tabTitle').addClass('jwsdw-justifyContentStretch');
        $productDetail.find('.jwsdw-jacketFinder-productDetail-tabLink').addClass('jwsdw-width100');
        $productDetail.find('.jwsdw-jacketFinder-productDetail-tabLink:last-child').addClass('jws-textAlignRight');

        $('.jwsdw-jacketFinder-compare').addClass('jws-hidden');
        $('.jwsdw-jacketFinder-compare-remove').removeClass('jws-hidden');
        $('.jwsdw-jacketFinder-compare-remove').each(function () {
            $(this).text($(this).text().toLowerCase());
        });

        window.jwsdwMediator.publish('closePicker', 'infoPicker', true);
    });

    $(document).on('click', '.jwsdw-jacketFinder-compare-remove', function() {
        var productId = $(this).attr('data-product-id');

        if (_selectedProduct === productId) {
            _selectedProduct = _compareWith;
        }
        _compareWith = null;

        $productDetail.find('.jwsdw-jacketFinder-productDetail-product').removeClass('jwsdw-jacketFinder-productDetail-compare');
        $productDetail.find('#jwsdw-jacketFinder-productDetail-product-' + productId).remove();
        $productDetail.find('.jwsdw-jacketFinder-productDetail-product')
            .removeClass('jws-grid-small-column-5')
            .addClass('jws-grid-small-column-10');
        $productDetail.find('.jwsdw-jacketFinder-productImage-container').addClass('jws-grid-medium-column-6');
        $productDetail.find('.jwsdw-jacketFinder-productDetail-container').addClass('jws-grid-medium-column-6');
        $productDetail.find('.jws-headline3, .jws-headline4').removeClass('jws-textAlignCenter');
        $productDetail.find('.jwsdw-jacketFinder-productDetail-tabTitle').removeClass('jwsdw-justifyContentStretch');
        $productDetail.find('.jwsdw-jacketFinder-productDetail-tabLink').removeClass('jwsdw-width100');
        $productDetail.find('.jwsdw-jacketFinder-productDetail-tabLink:last-child').removeClass('jws-textAlignRight');

        $('.jwsdw-jacketFinder-compare').removeClass('jws-hidden');
        $('.jwsdw-jacketFinder-compare-remove').addClass('jws-hidden');
    });

    $(window).on('resize', window.jwsdwUtil.debounce(300, function() {
        if (/small/.test(window.jwsdwUtil.uiUtils.getViewport())) {
            $('.jwsdw-jacketFinder-productDetail-product').not('.jws-visuallyHidden').find('.jwsdw-jacketFinder-compare-remove').eq(1).click();
        }
    }));

    /**
     * @description Method to build cateogry Id based on user inputs
     * @param {String} type tent type
     * @param {String} [activity] activity
     * @returns {String} cateogry Id
     */
    function buildCategoryId(type) {
        var parts = [
            type,
            'Beratung-Jackenfinder'
        ];

        return parts.join('-');
    }

    /**
     * @description Method to trigger product search
     * @param {Function} callback callback function
     * @param {Boolean} updateFrontend if true show loading animation on frontend
     * @param {Integer} [offset] offset for product search. Used for pagination.
     * @returns {void}
     */
    function search(callback, updateFrontend, offset) {
        var cgids,
            _xhrs = [];

        xhrs.forEach(function (xhr) {
            if (xhr && xhr.hasOwnProperty('abort')) {
                xhr.abort();
            }
        });

        if (updateFrontend) {
            $productSearchResult.find('.jwsdw-spinner').removeClass('jws-hidden');
            $productSearchResult.find('.jwsdw-jacketFinder-searchResult-slider-wrapper').addClass('jws-hidden');
            $productSearchResult.find('.jwsdw-jacketFinder-triangle-container').addClass('jws-hidden');
        }

        if ($('.jwsdw-jacketFinder-type:checked').val()) {
            cgids = [
                buildCategoryId(
                    $('.jwsdw-jacketFinder-type:checked').val()
                )
            ];
        } else {
            cgids = [
                buildCategoryId(
                    $('.jwsdw-jacketFinder-type').eq(0).val()
                ),
                buildCategoryId(
                    $('.jwsdw-jacketFinder-type').eq(1).val()
                )
            ];
        }

        Promise
            .all(cgids.map(function (cgid) {
                return new Promise(function (resolve) {
                    let _currentSearch = cgid,
                        data = {
                            'cgid': cgid,
                            'reducedProductData': true
                        },
                        tempArr;


                    if ($('.jwsdw-jacketFinder-activity:checked').val()) {
                        data.prefn5 = 'refinementAktivitaet';
                        data.prefv5 = $('.jwsdw-jacketFinder-activity:checked').val();
                        _currentSearch += '-' + data.prefv5;
                    }

                    if ($('.jwsdw-jacketFinder-function:checked').val()) {
                        tempArr = $('.jwsdw-jacketFinder-function:checked').map(function(){return $(this).val()}).get(); //eslint-disable-line
                        for (let i = 0; i < tempArr.length; i++) {
                            data['prefn' + (i + 6)] = 'refinementFunktion';
                            data['prefv' + (i + 6)] = tempArr[i];
                            _currentSearch += '-' + data['prefv' + (i + 6)];
                        }
                    }

                    if ($('.jwsdw-jacketFinder-attribute:checked').val()) {
                        tempArr = $('.jwsdw-jacketFinder-attribute:checked').map(function(){return $(this).val()}).get(); //eslint-disable-line
                        for (let i = 0; i < tempArr.length; i++) {
                            data['prefn' + (i + 12)] = 'refinementAusstattungsdetails';
                            data['prefv' + (i + 12)] = tempArr[i];
                            _currentSearch += '-' + data['prefv' + (i + 12)];
                        }
                    }

                    if (offset) {
                        data.start = offset;
                        _currentSearch += '-' + offset;
                    }

                    _xhrs.push($.ajax({
                        'url': window.jwsdwSettings.baseUrl + '/Search-searchProducts',
                        'data': data,
                        'success': function (response) {
                            _cache[_currentSearch] = response;
                            resolve(response);
                        }
                    }));
                });
            }))
            .then(function(data) {
                var productSearchResult = data.reduce(function(obj, result) {
                    if (!result.categoryId) {
                        return obj;
                    }

                    let productMap = new Map(),
                        combinedProductSearchHits = (obj.productSearchHits || []).concat(result.productSearchHits),
                        uniqueProductSearchHits;

                    combinedProductSearchHits.forEach(hit => {
                        productMap.set(hit.ID, hit);
                    });

                    uniqueProductSearchHits = Array.from(productMap.values());

                    return {
                        'pagingModels': (obj.pagingModels || []).concat(result.pagingModel),
                        'productSearchHits': uniqueProductSearchHits
                    };
                }, {});

                let uniqueProductHits = productSearchResult.productSearchHits.filter(hit =>
                    !_productSearchHits.some(existingHit => existingHit.ID === hit.ID)
                );

                _productSearchHits = _productSearchHits.concat(uniqueProductHits);
                _offset = productSearchResult.pagingModels[0].pageEnd + 1;

                // if "no type preference" is selected randomize results
                if (!$('.jwsdw-jacketFinder-type:checked').val()) {
                    productSearchResult.productSearchHits = productSearchResult.productSearchHits.sort( (a, b) => 0.5 - Math.random() ); //eslint-disable-line
                }

                callback(productSearchResult, updateFrontend);
            });

        if (updateFrontend) {
            xhrs = _xhrs;
        }
    }

    /**
     * @description Method to get filter hit count of search
     * @param {Function} callback callback function
     * @param {Boolean} updateActivities if true update activity tiles as well
     * @param {Boolean} updateFunctions if true update capacity tiles as well
     * @param {Boolean} updateAttributes if true update capacity tiles as well
     * @returns {void}
     */
    function getFilterHitCount(callback, updateActivities, updateFunctions, updateAttributes) {
        var cgids,
            _filterHitCountXhrs = [];

        filterHitCountXhrs.forEach(function (xhr) {
            if (xhr && xhr.hasOwnProperty('abort')) {
                xhr.abort();
            }
        });

        if ($('.jwsdw-jacketFinder-type:checked').val()) {
            cgids = [
                buildCategoryId(
                    $('.jwsdw-jacketFinder-type:checked').val()
                )
            ];
        } else {
            cgids = [
                buildCategoryId(
                    $('.jwsdw-jacketFinder-type').eq(0).val()
                ),
                buildCategoryId(
                    $('.jwsdw-jacketFinder-type').eq(1).val()
                )
            ];
        }

        Promise
            .all(cgids.map(function (cgid) {
                return new Promise(function (resolve) {
                    var data = {
                            'cgid': cgid
                        },
                        tempArr;

                    if ($('.jwsdw-jacketFinder-activity:checked').val()) {
                        data.prefn5 = 'refinementAktivitaet';
                        data.prefv5 = $('.jwsdw-jacketFinder-activity:checked').val();
                    }

                    if ($('.jwsdw-jacketFinder-function:checked').val()) {
                        tempArr = $('.jwsdw-jacketFinder-function:checked').map(function(){return $(this).val()}).get(); //eslint-disable-line
                        for (let i = 0; i < tempArr.length; i++) {
                            data['prefn' + (i + 6)] = 'refinementFunktion';
                            data['prefv' + (i + 6)] = tempArr[i];
                        }
                    }

                    if ($('.jwsdw-jacketFinder-attribute:checked').val()) {
                        tempArr = $('.jwsdw-jacketFinder-attribute:checked').map(function(){return $(this).val()}).get(); //eslint-disable-line
                        for (let i = 0; i < tempArr.length; i++) {
                            data['prefn' + (i + 12)] = 'refinementAusstattungsdetails';
                            data['prefv' + (i + 12)] = tempArr[i];
                        }
                    }

                    if (_cache['filterHitCount-' + cgid + '-' + data.prefv5 + '-' + data.prefv6 + '-' + data.prefv7]) {
                        resolve(_cache['filterHitCount-' + cgid + '-' + data.prefv5 + '-' + data.prefv6 + '-' + data.prefv7]);
                        return;
                    }

                    _filterHitCountXhrs.push($.ajax({
                        'url': window.jwsdwSettings.baseUrl + '/Search-FilterHitCount',
                        'data': data,
                        'success': function (response) {
                            _cache['filterHitCount-' + cgid + '-' + data.prefv5 + '-' + data.prefv6 + '-' + data.prefv7] = response;
                            resolve(response);
                        }
                    }));
                });
            }))
            .then(function(data) {
                var filterHitCount = data.reduce(function(obj, result) {
                    var refinementAktivitaet = result.refinements.find(function(refinement) {
                            return refinement.id === 'refinementAktivitaet';
                        }),
                        refinementFunktion = result.refinements.find(function(refinement) {
                            return refinement.id === 'refinementFunktion';
                        }),
                        refinementAusstattungsdetails = result.refinements.find(function(refinement) {
                            return refinement.id === 'refinementAusstattungsdetails';
                        });

                    if (updateActivities) {
                        if (!obj.refinementAktivitaet && refinementAktivitaet) {
                            obj.refinementAktivitaet = refinementAktivitaet;
                        } else if (refinementAktivitaet) {
                            refinementAktivitaet.refinementValues.forEach(function(refinementValue) {
                                var exists = obj.refinementAktivitaet.refinementValues.some(function(currentRefinementValue) {
                                    return refinementValue.value === currentRefinementValue.value;
                                });
                                if (!exists) {
                                    obj.refinementAktivitaet.refinementValues.push(refinementValue);
                                }
                            });
                            obj.refinementAktivitaet.refinementValues = obj.refinementAktivitaet.refinementValues.map(function(refinementValue) {
                                var value = refinementAktivitaet.refinementValues.find(function(currentRefinementValue) {
                                    return refinementValue.value === currentRefinementValue.value;
                                });

                                if (value) {
                                    refinementValue.hitCount += value.hitCount;
                                }
                                return refinementValue;
                            });
                        }
                    }
                    if (updateFunctions) {
                        if (!obj.refinementFunktion && refinementFunktion) {
                            obj.refinementFunktion = refinementFunktion;
                        } else if (refinementFunktion) {
                            refinementFunktion.refinementValues.forEach(function(refinementValue) {
                                var exists = obj.refinementFunktion.refinementValues.some(function(currentRefinementValue) {
                                    return refinementValue.value === currentRefinementValue.value;
                                });
                                if (!exists) {
                                    obj.refinementFunktion.refinementValues.push(refinementValue);
                                }
                            });
                            obj.refinementFunktion.refinementValues = obj.refinementFunktion.refinementValues.map(function(refinementValue) {
                                var value = refinementFunktion.refinementValues.find(function(currentRefinementValue) {
                                    return refinementValue.value === currentRefinementValue.value;
                                });

                                if (value) {
                                    refinementValue.hitCount += value.hitCount;
                                }
                                return refinementValue;
                            });
                        }
                    }
                    if (updateAttributes) {
                        if (!obj.refinementAusstattungsdetails && refinementAusstattungsdetails) {
                            obj.refinementAusstattungsdetails = refinementAusstattungsdetails;
                        } else if (refinementAusstattungsdetails) {
                            refinementAusstattungsdetails.refinementValues.forEach(function(refinementValue) {
                                var exists = obj.refinementAusstattungsdetails.refinementValues.some(function(currentRefinementValue) {
                                    return refinementValue.value === currentRefinementValue.value;
                                });
                                if (!exists) {
                                    obj.refinementAusstattungsdetails.refinementValues.push(refinementValue);
                                }
                            });
                            obj.refinementAusstattungsdetails.refinementValues = obj.refinementAusstattungsdetails.refinementValues.map(function(refinementValue) {
                                var value = refinementAusstattungsdetails.refinementValues.find(function(currentRefinementValue) {
                                    return refinementValue.value === currentRefinementValue.value;
                                });

                                if (value) {
                                    refinementValue.hitCount += value.hitCount;
                                }
                                return refinementValue;
                            });
                        }
                    }
                    return obj;
                }, {
                    'refinementCategory': null,
                    'refinementAktivitaet': null,
                    'refinementFunktion': null,
                    'refinementAusstattungsdetails': null

                });

                callback(filterHitCount);
            });

        filterHitCountXhrs = _filterHitCountXhrs;
    }

    /**
     * @description Method for productdetail tabs
     * @returns {void}
     */
    $(document).on('click', '.jwsdw-jacketFinder-productDetail-tabLink', function () {
        var $container = $(this).parents('.jwsdw-jacketFinder-productDetail-tabContainer'),
            tabId = $(this).attr('data-tab-id');

        $container.find('.jwsdw-jacketFinder-productDetail-tabLink').removeClass('jwsdw-borderYellow-2px-bottom jwsdw-borderGrey4-bottom');
        $container.find('.jwsdw-jacketFinder-productDetail-tabLink').addClass('jwsdw-borderGrey4-bottom');
        $container.find('.jwsdw-jacketFinder-productDetail-tabContent').addClass('jws-hidden');

        $(this).addClass('jwsdw-borderYellow-2px-bottom jwsdw-borderGrey4-bottom');
        $(this).removeClass('jwsdw-borderGrey4-bottom');

        $container.find('.jwsdw-jacketFinder-productDetail-tabContent[data-tab-id=' + tabId + ']').removeClass('jws-hidden');
    });

    /**
     * @description Method to build the HTML for the product detail change on the page
     * @param {Object[]} productSearchHits search results
     * @param {String} productID product id
     * @returns {void}
     */
    function buildProductDetail(productSearchHits, productID) {
        $productDetail.html('');

        productSearchHits = productSearchHits
            .filter(function(product) {
                return product.ID === productID;
            })
            .map(function (product) {
                var $productDetailProduct = $productDetailTemplate.clone();

                $productDetailProduct.find('.jwsdw-jacketFinder-productImage').attr(
                    'src',
                    window.jwsdwUtil.urlUtils.imageUrl(product.ID, 0, transforms.productDetail, 'Bone5')
                );

                $productDetailProduct.attr('data-product-id', product.ID);
                $productDetailProduct.attr('id', 'jwsdw-jacketFinder-productDetail-product-' + product.ID);

                $productDetailProduct.find('.jwsdw-productName').text(product.displayedName || product.name);
                $productDetailProduct.find('.jwsdw-productPrice').text(product.pricing.priceFormatted);
                $productDetailProduct.find('.jwsdw-jacketFinder-shopNow, .jwsdw-jacketFinder-compare, .jwsdw-jacketFinder-compare-remove').attr('data-product-id', product.ID);
                if ($('.jwsdw-jacketFinder-productSlide').length - 1 === 1) {
                    $productDetailProduct.find('.jwsdw-jacketFinder-compare').addClass('jws-hidden');
                    $productDetailProduct.find('.jwsdw-jacketFinder-compare-remove').addClass('jws-hidden');
                } else {
                    $productDetailProduct.find('.jwsdw-jacketFinder-compare').removeClass('jws-hidden');
                    $productDetailProduct.find('.jwsdw-jacketFinder-compare-remove').addClass('jws-hidden');
                }
                product.info.forEach(function (info) {
                    $productDetailProduct.find('.jwsdw-pdp-detailList').append(
                        $('<li>' + info + '</li>')
                    );
                });
                product.technology.forEach(function (technology) {
                    var $technologyLogo = $technologyLogoTemplate.clone();

                    $technologyLogo.removeAttr('id').removeClass('jws-hidden');
                    if (technology.cid) {
                        $technologyLogo.find('.jwsdw-badgeContainer').addClass('jws-cursorPointer');
                        $technologyLogo.find('.jwsdw-badgeContainer').attr('data-picker-options', JSON.stringify({
                            'cid': technology.cid,
                            'introduction': technology.excerpt,
                            'width': 1
                        }));
                    } else {
                        $technologyLogo.find('.jwsdw-badge').remove();
                    }
                    $technologyLogo.find('.jwsdw-techLogo').attr('src', technology.imageUrl);
                    $productDetailProduct.find('.jwsdw-jacketFinder-productDetail-technologies').append($technologyLogo);
                });

                $productDetail.append($productDetailProduct);

                return product;
            });

        if (productSearchHits.length === 0) {
            $productSearchResult.find('.jwsdw-jacketFinder-searchResult-no-results').removeClass('jws-hidden');

            return;
        }
    }

    /**
     * @description Method to build the HTML on the page
     * @param {Object[]} productSearchResult search results
     * @returns {void}
     */
    function buildHTML(productSearchResult) {
        let productSearchHits = productSearchResult.productSearchHits,
            pagingModels = productSearchResult.pagingModels;
        if (sliders.product) {
            sliders.product.destroy();
        }
        sliders.productImage = {};

        $productSlider.find('.swiper-wrapper').html('');
        $productDetail.html('');
        $productSearchResult.find('.jwsdw-spinner').addClass('jws-hidden');

        productSearchHits = _updateProductSlider(productSearchHits, pagingModels);

        if (productSearchHits.length === 0) {
            $productSearchResult.find('.jwsdw-jacketFinder-searchResult-no-results').removeClass('jws-hidden');

            return;
        }

        $productSearchResult.find('.jwsdw-jacketFinder-searchResult-no-results').addClass('jws-hidden');

        $productSearchResult.find('.jwsdw-jacketFinder-searchResult-slider-wrapper').removeClass('jws-hidden');
        $productSearchResult.find('.jwsdw-jacketFinder-triangle-container').removeClass('jws-hidden');

        sliders.product = new Swiper('#' + $productSlider.attr('id'), sliderOptions.productSlider);

        $productSlider.removeClass('jws-hidden');
        sliders.product.on('init', _updateFakeArrows);
        sliders.product.on('slideChange', _updateFakeArrows);
        sliders.product.on('reachEnd', _loadMore);
        sliders.product.on('resize', window.jwsdwUtil.debounce(300, _updateFakeArrows));

        sliders.product.init();

        $('#jwsdw-jacketFinder-productSlider .jwsdw-jacketFinder-productSlide').eq(0).click();
    }

    /**
     * @description Method to deactivate refinement tiles that don't yield results
     * @param {Object} filterHitCount filter hit count result
     * @returns {void}
     */
    function deactivateEmptyRefinements(filterHitCount) {
        $activitySelect.each(function () {
            var regex = new RegExp(this.value),
                value = filterHitCount.refinementAktivitaet && filterHitCount.refinementAktivitaet.refinementValues.find(function(refinementValue) {
                    return regex.test(refinementValue.value);
                });

            if (value && value.hitCount > 0) {
                $(this).removeAttr('disabled');
                $(this).next('.jwsdw-productFinder-refinementStep-tile').find('.jwsdw-productFinder-icon-activities').addClass('jwsdw-fillColorGrey1').removeClass('jwsdw-fillColorBone3'); //eslint-disable-line
                $(this).next('.jwsdw-productFinder-refinementStep-tile').find('.jwsdw-text-refinement').addClass('jws-colorBlack').removeClass('jws-colorBone3'); //eslint-disable-line
            } else {
                if ($(this).is(':checked')) {
                    $('#jwsdw-jacketFinder-activity-none').prop('checked', true);
                }
                $(this).attr('disabled', 'disabled');
                $(this).next('.jwsdw-productFinder-refinementStep-tile').find('.jwsdw-productFinder-icon-activities').addClass('jwsdw-fillColorBone3').removeClass('jwsdw-fillColorGrey1'); //eslint-disable-line
                $(this).next('.jwsdw-productFinder-refinementStep-tile').find('.jwsdw-text-refinement').addClass('jws-colorBone3').removeClass('jws-colorBlack'); //eslint-disable-line
            }
            $(this).next('.jwsdw-productFinder-refinementStep-tile').find('.jwsdw-spinner').addClass('jws-hidden');
        });

        $functionSelect.each(function () {
            var regex = new RegExp(this.value),
                value = filterHitCount.refinementFunktion && filterHitCount.refinementFunktion.refinementValues.find(function(refinementValue) {
                    return regex.test(refinementValue.value);
                });

            if (value && value.hitCount > 0) {
                $(this).removeAttr('disabled');
                $(this).next('.jwsdw-productFinder-refinementStep-tile').find('.jwsdw-productFinder-icon-functions').addClass('jwsdw-fillColorGrey1').removeClass('jwsdw-fillColorBone3'); //eslint-disable-line
                $(this).next('.jwsdw-productFinder-refinementStep-tile').find('.jwsdw-text-refinement').addClass('jws-colorBlack').removeClass('jws-colorBone3'); //eslint-disable-line
            } else {
                if ($(this).is(':checked')) {
                    $('#jwsdw-jacketFinder-function-none').prop('checked', true);
                }
                $(this).attr('disabled', 'disabled');
                $(this).next('.jwsdw-productFinder-refinementStep-tile').find('.jwsdw-productFinder-icon-functions').addClass('jwsdw-fillColorBone3').removeClass('jwsdw-fillColorGrey1'); //eslint-disable-line
                $(this).next('.jwsdw-productFinder-refinementStep-tile').find('.jwsdw-text-refinement').addClass('jws-colorBone3').removeClass('jws-colorBlack'); //eslint-disable-line
            }
            $(this).next('.jwsdw-productFinder-refinementStep-tile').find('.jwsdw-spinner').addClass('jws-hidden');
        });

        $attributeSelect.each(function () {
            var regex = new RegExp(this.value),
                value = filterHitCount.refinementAusstattungsdetails && filterHitCount.refinementAusstattungsdetails.refinementValues.find(function(refinementValue) {
                    return regex.test(refinementValue.value);
                });

            if (value && value.hitCount > 0) {
                $(this).removeAttr('disabled');
                $(this).next('.jwsdw-productFinder-refinementStep-tile').find('.jwsdw-productFinder-icon-functions').addClass('jwsdw-fillColorGrey1').removeClass('jwsdw-fillColorBone3'); //eslint-disable-line
                $(this).next('.jwsdw-productFinder-refinementStep-tile').find('.jwsdw-text-refinement').addClass('jws-colorBlack').removeClass('jws-colorBone3'); //eslint-disable-line
            } else {
                if ($(this).is(':checked')) {
                    $('#jwsdw-jacketFinder-attribute-none').prop('checked', true);
                }
                $(this).attr('disabled', 'disabled');
                $(this).next('.jwsdw-productFinder-refinementStep-tile').find('.jwsdw-productFinder-icon-functions').addClass('jwsdw-fillColorBone3').removeClass('jwsdw-fillColorGrey1'); //eslint-disable-line
                $(this).next('.jwsdw-productFinder-refinementStep-tile').find('.jwsdw-text-refinement').addClass('jws-colorBone3').removeClass('jws-colorBlack'); //eslint-disable-line
            }
            $(this).next('.jwsdw-productFinder-refinementStep-tile').find('.jwsdw-spinner').addClass('jws-hidden');
        });
    }

    /**
     * @description Method to update product slider fake arrows
     * @returns {void}
     * @private
     */
    function _updateFakeArrows() {
        setTimeout(function() {
            if ($productSlider.find('.swiper-button-prev.swiper-button-disabled').length > 0) {
                $('#jwsdw-jacketFinder-productSlider-prev').addClass('swiper-button-disabled');
            } else {
                $('#jwsdw-jacketFinder-productSlider-prev').removeClass('swiper-button-disabled');
            }
            if ($productSlider.find('.swiper-button-next.swiper-button-disabled').length > 0) {
                $('#jwsdw-jacketFinder-productSlider-next').addClass('swiper-button-disabled');
            } else {
                $('#jwsdw-jacketFinder-productSlider-next').removeClass('swiper-button-disabled');
            }
        });
    }

    /**
     * @description Method to load more product results
     * @returns {undefined}
     * @private
     */
    function _loadMore() {
        if ($productSlider.find('.jwsdw-placeholderSlide').length) {
            search(
                (productSearchResult) => {
                    let productSearchHits = productSearchResult.productSearchHits,
                        pagingModels = productSearchResult.pagingModels;

                    $productSlider.find('.jwsdw-placeholderSlide').remove();

                    _updateProductSlider(productSearchHits, pagingModels);
                    sliders.product.update();
                    _updateFakeArrows();
                },
                false,
                _offset
            );
        }
    }

    /**
     * @description Helper function to add product search hits to swiper slides.
     * @param {*} productSearchHits - Array of product search hits.
     * @param {*} pagingModels - Array of product search result paging models.
     * @returns {Object[]} an array of product search hits.
     */
    function _updateProductSlider(productSearchHits, pagingModels) {
        let pHits = productSearchHits
            .filter(function(product) {
                return product.pricing.standard;
            })
            .map(function (product) {
                var $productSlide = $productSlideTemplate.clone(),
                    $productDetailProduct = $productDetailTemplate.clone();

                $productSlide.removeClass('jws-hidden').removeAttr('id');

                $productSlide.attr('data-product-id', product.ID);
                $productSlide
                    .find('.jwsdw-productTile-image')
                    .attr(
                        'data-src',
                        window.jwsdwUtil.urlUtils.imageUrl(product.ID, 0, transforms.slider, 'Bone5')
                    )
                    .attr(
                        'alt',
                        product.displayedName || product.name
                    );
                $productSlide.find('.jwsdw-productName').text(product.displayedName || product.name);
                $productDetailProduct.find('.jwsdw-jacketFinder-productImage').attr(
                    'src',
                    window.jwsdwUtil.urlUtils.imageUrl(product.ID, 0, transforms.productDetail, 'Bone5')
                );

                $productSlide.find('.jwsdw-productName').text(product.name);
                if (product.pricing.sale && product.pricing.sale < product.pricing.standard) {
                    // has sale price
                    $productSlide.find('.jwsdw-productListPrice')
                        .addClass('jwsdw-lineThrough jws-copy1 jws-colorGrey3')
                        .text(window.jwsdwUtil.formatPrice(product.pricing.standard));
                    $productSlide.find('.jwsdw-productSalePrice')
                        .removeClass('jws-hidden')
                        .text(window.jwsdwUtil.formatPrice(product.pricing.sale));
                } else {
                    $productSlide.find('.jwsdw-productListPrice').text(window.jwsdwUtil.formatPrice(product.pricing.standard));
                }
                $productSlider.find('.swiper-wrapper').append($productSlide);

                return product;
            });

        if (pagingModels.some((pagingModel) => pagingModel.hasNextPage)) {
            let $productSlide = $productSlidePlaceholderTemplate.clone();
            $productSlide.removeAttr('id').removeClass('jws-hidden');
            $productSlider.find('.swiper-wrapper').append($productSlide);
        }

        return pHits;
    }

    /**
     * @description Method to scroll to the top of an element. Additionally an offset can be passed.
     * @param {Object} element jQuery element for which offset.top defines the scroll position
     * @param {Integer} [offset] optional offset
     * @returns {void}
     */
    function scrollTop(element, offset) {
        offset = offset || 0;
        $('html, body').animate({
            'scrollTop': element.offset().top + offset
        });
    }

    if (!!window.navigator.userAgent.match(/Trident/g) || !!window.navigator.userAgent.match(/MSIE/g)) {
        // IE11 fix to remove second scrollbar when search results loaded
        $('#jwsdw-body').css('overflow', 'visible');
    }
}(jQuery, Swiper, Promise)); // eslint-disable-line no-undef
